import React, { Component } from 'react';
import Intro from '../../components/Intro';
import Goal from '../../components/Goal';
import Pattern from '../../components/Pattern';
import Progress from '../../components/Progress';
import Inspiration from '../../components/Inspiration';
import Reflection from '../../components/Reflection';
import Summary from '../../components/Summary';
import Overview from '../../components/Overview';
import MotivationalFeeInvoice from '../../components/MotivationalFeeInvoice';
import styles from './Spa.module.scss'; //playing a big role even though I don't see where it's used

class Conntainer extends Component {
	//'/images/image-name.png'

	render() {
		return (
			<div style={{ overflow: 'hidden'}}>
				<Intro />
				<Goal />
				<Pattern />
				<Inspiration />
				<Overview />
				<Progress />
				<MotivationalFeeInvoice />
				<Reflection />
				<Summary />
			</div>
		);
	}
}

export default Conntainer;

